import get from 'lodash/get';
import { CARD_DETAILS_FORM_ID } from '../form/configs/cardDetails';
import { sendNewRelicCustomEvent } from '../logging/logging-utils';

const logUnsupportedCardType = () => (dispatch, getState) => {
  const binRange = get(getState(), `form[${CARD_DETAILS_FORM_ID}].values.cardNumber`, '')
    .replace(' ', '')
    .substring(0, 6);

  sendNewRelicCustomEvent('unsupportedBinRange', { binRange });
};

export default logUnsupportedCardType;
